import { createFileRoute } from '@tanstack/react-router';

import { VerifySamlPage } from 'src/apps/enterprise/app/pages/VerifySaml';

export const Route = createFileRoute('/_auth/enterprise/enroll/verify-saml')({
  component: () => <VerifySamlPage />,
});
